<template>
  <v-app>
    <v-container fill-height pl-12 pb-0 pt-0 fluid>
      <v-layout row align-space-between justify-space-between>
        <v-flex lg4 pr-2 pt-12>
          <fe :articleList="leftFe" />
        </v-flex>
        <v-flex lg4 pr-1 pl-1>
          <md />
        </v-flex>
        <v-flex lg4 pl-2 pt-12>
          <fe :articleList="rightFe" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import fe from "../components/CoverPage/Featured.vue";
import md from "../components/CoverPage/Middle.vue";
export default {
  name: "Home",
  components: {
    fe,
    md
  },
  data: () => ({
    leftFe: [
      {
        color: "#1F7087",
        authName: "Andreea Coscai",
        author: {
          name: "Andreea Coscai",
          title: "",
          bio: ""
        },
        link: "whose-choice-is-my-choice",
        title: "Whose Choice is My Choice",
        items: [require("@/assets/PA/Podcast/Andreea_Coscai/image1.png")]
      },
      {
        color: "#952175",
        authName: "Hafsa Zulfiqar",
        author: {
          name: "Hafsa Zulfiqar",
          title: "",
          bio: ""
        },
        link: "the-one-who-was-named-before-his-birth",
        title: "the one who was named before his birth"
      },
      {
        color: "#6d00ff",
        authName: "Ayesha Bashir",
        author: {
          name: "Ayesha Bashir",
          title: "",
          bio:
            "I am Ayesha Bashir from Karachi, Pakistan. I studied sciences for most of my life. Coming from a conventional middle-class family I wasn’t allowed to study the arts. I discovered my love for the arts in my senior year of high school. To me, making films is a way of survival. My work deals with topics like diaspora, alienation, and the universality of emotions."
        },
        link: "0-28",
        title: "0:28",
        items: [require("@/assets/VA/Videos/Ayesha_Bashir/image1.png")]
      }
    ],
    rightFe: [
      {
        color: "#1F7087",
        authName: "Kale Eposito",
        author: {
          name: "Kale Eposito",
          title: "",
          bio: ""
        },
        link: "4-yellow-windows",
        title: "4 Yellow Windows",
        items: [require("@/assets/VA/PDS/Kale_Esposito/image1.jpg")]
      },
      {
        color: "#952175",
        authName: "Xiao Ma",
        author: {
          name: "Xiao Ma",
          title: "",
          bio: ""
        },
        link: "the-only-virus-present-is-your-racism",
        title: "The only virus present is your racism ",
        items: [
          require("@/assets/VA/Photography/Xiao_Ma/1.jpg"),
          require("@/assets/VA/Photography/Xiao_Ma/2.jpg"),
          require("@/assets/VA/Photography/Xiao_Ma/3.jpg"),
          require("@/assets/VA/Photography/Xiao_Ma/4.jpg"),
          require("@/assets/VA/Photography/Xiao_Ma/5.jpg"),
          require("@/assets/VA/Photography/Xiao_Ma/6.jpg")
        ]
      },
      {
        color: "#6d00ff",
        authName: "Alyssa Pong",
        author: {
          name: "Alyssa Pong",
          title: "",
          bio: ""
        },
        link: "i-dont-know-what-to-say",
        title: "I Don't Know What to Say",
        items: [
          require("@/assets/Alyssa/pic1.png"),
          require("@/assets/Alyssa/pic2.png"),
          require("@/assets/Alyssa/pic3.png"),
          require("@/assets/Alyssa/pic4.png")
        ]
      }
    ]
  }),
  created() {
    console.log(this.$vuetify.application.top);
  }
};
</script>
